import { type ReactNode, useEffect, useState } from "react";

import { useSearchParams } from "react-router-dom";

import {
  filtersKey,
  mergeParams,
  pickParams,
  readSavedParams,
  writeSavedParams,
} from "@/lib/table-state";

interface RememberParamsProps {
  /** Jadval nomi — kalit `aimly-admin:<table>:filters`. */
  table: string;
  /** Eslab qolinadigan parametrlar (filtrlar va sahifa hajmi, sahifa raqami EMAS). */
  keys: readonly string[];
  children: ReactNode;
}

/**
 * Filtrlarni eslab qoladi.
 *
 * Manzil — yagona manba va havola ulashilganda aynan o'sha ro'yxat ochiladi.
 * Lekin menyudan qaytib kelinganda manzil toza bo'ladi va tanlangan filtrlar
 * yo'qolardi. Shu uchun: sahifa filtrsiz ochilsa va avval saqlangan tanlov
 * bo'lsa — u manzilga qaytariladi; keyin har o'zgarish yana saqlanadi.
 *
 * Tiklash faqat OCHILISHDA bo'ladi: odam filtrlarni o'zi tozalasa, bo'sh
 * tanlov saqlanadi va keyingi safar ham toza ochiladi. Tiklanguncha bolalar
 * chizilmaydi — aks holda filtrsiz so'rov ketib, keyin qayta yuborilardi.
 */
export function RememberParams({ table, keys, children }: RememberParamsProps) {
  const [params, setParams] = useSearchParams();
  const key = filtersKey(table);
  const current = pickParams(params, keys);
  const [pending, setPending] = useState(() => !current && readSavedParams(key) !== "");

  // Manzil yangilandi — tiklash tugadi. Render paytida: qo'shimcha render yo'q.
  if (pending && current) setPending(false);

  useEffect(() => {
    if (!pending) return;
    const saved = readSavedParams(key);
    setParams(prev => mergeParams(prev, saved), { replace: true });
  }, [pending, key, setParams]);

  useEffect(() => {
    if (!pending) writeSavedParams(key, current);
  }, [pending, key, current]);

  return pending ? null : children;
}
